export const recipients = {
    state: {
        recipients: [],
        status: 'idle',
        recipientsAmount: 5
    },
    mutations: {
        ADD_RECIPIENT(state, payload) {
            state.recipients = [...state.recipients, payload]
        },
        SET_RECIPIENTS(state, payload) {
            state.recipients = []
            state.recipients = payload
        },
        SET_RECIPIENTS_STATUS(state, payload) {
            state.status = payload
        }
    },
    actions: {
        deleteRecipient({ state, commit }, payload) {
            return this.$api.delete(`sms_notifications/recipients/${payload}`).then(res => {
                const tmpState = state.recipients
                const itemIdx = state.recipients
                    .map(rec => rec.id)
                    .indexOf(payload)
                tmpState[itemIdx] = { name: '', phone: '', id: '' }
                commit('SET_RECIPIENTS', tmpState)
                return res
            })
        },
        recipientAdd({ state, commit }, payload) {
            const { phone, name } = payload
            return this.$api.post('sms_notifications/recipients', { name, phone }).then(res => {
                if (!res.data.data.errors) {
                    const tmpRecipient = state.recipients
                    tmpRecipient[payload.recipientIdx] = res.data.data
                    commit('SET_RECIPIENTS', tmpRecipient)
                }
                return res
            })
        },
        recipientsFetch({ state, commit }) {
            if (state.status === 'idle') {
                commit('SET_RECIPIENTS_STATUS', 'loading')
                return this.$api
                    .get('sms_notifications/recipients')
                    .then(res => {
                        if (!res.data.data) res.data.data = []
                        const recipients = res.data.data.sort(
                            (a, b) => a.id - b.id
                        )
                        for (
                            let i = recipients.length;
                            i < state.recipientsAmount;
                            i++
                        ) {
                            recipients.push({ name: '', phone: '', id: '' })
                        }
                        commit('SET_RECIPIENTS', recipients)
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => {
                        commit('SET_RECIPIENTS_STATUS', 'idle')
                    })
            }
        },
        clearRecipients({ commit }) {
            commit('SET_RECIPIENTS', [])
        }
    },
    getters: {
        getRecipients: state => {
            if (state.recipients) {
                return state.recipients
            }
        }
    }
}
